import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { alertActions } from '../redux/AlertController';

export const useProfits = () => {
    const [summary, setSummary] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [debts, setDebts] = useState(null);
    const [debtsLoading, setDebtsLoading] = useState(false);
    const dispatch = useDispatch();
    const user = useSelector(state => state.userController.user);

    const authGet = async (path, params) => {
        const qs = params ? `?${new URLSearchParams(params)}` : '';
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/profits${path}${qs}`, {
            headers: { 'Authorization': `Bearer ${user?.token}` }
        });
        const json = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(json.error || 'تعذر جلب البيانات');
        return json;
    };

    // Totals, averages, chart buckets, breakdowns and transactions for one period.
    const fetchSummary = async ({ type, source = 'all', startDate, endDate, granularity }) => {
        if (!user?.token) return null;
        setIsLoading(true);
        try {
            const json = await authGet('/summary', { type, source, startDate, endDate, granularity });
            setSummary(json);
            return json;
        } catch (error) {
            dispatch(alertActions.showAlert({ msg: error.message, type: 'error' }));
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    // Drivers with a negative balance (money owed to the company).
    const fetchDebts = async () => {
        if (!user?.token) return null;
        setDebtsLoading(true);
        try {
            const json = await authGet('/driver-debts');
            setDebts(json);
            return json;
        } catch (error) {
            dispatch(alertActions.showAlert({ msg: error.message, type: 'error' }));
            return null;
        } finally {
            setDebtsLoading(false);
        }
    };

    return {
        summary,
        isLoading,
        fetchSummary,
        debts,
        debtsLoading,
        fetchDebts
    };
};
